
<template>
    <section>
        <p class="title is-5" v-if="!dashboard">
            
            <i class="fa fa-bolt"></i>
            Credits usage</p>
                    
                    
                        
                            <p class="subtitle is-6">
                            Used {{ creditsUsed }} out of {{ creditsQuota }} credits. 
                            <span v-if="creditsRemaining < 400">Consider upgrade to reserve more credits per month.</span>
                            </p>

                        <b-field position="is-centered" message="Reset on 1st next month">
                            <b-progress style="margin-bottom: 0em;" size="is-medium" type="is-primary" :max="creditsQuota" :value="creditsRemaining" show-value>
                                <i class="fa fa-bolt"></i>
                                {{ creditsRemaining }} remaining
                            </b-progress>
                        </b-field>
                        
                    
                    

</section>
</template>

<script>
    export default {
      props: ["dashboard"],
      data() {
        return {
            creditsUsed: 0,
            creditsRemaining: 0,
            creditsQuota: 500
        };
      },
      computed: {
      currentUser() {
        return this.$store.state.currentUser;
      },
    },
    methods: {
      isAdditionalCredits(){
          this.$buefy.snackbar.open(`For additional credits, please mail us at help@metatext.io with the credit amount you need<br>We'll send you a payment link according with the credit amount you want.`)
      },
    },
      mounted() {
    
        let creditsQuota = this.currentUser.creditsQuota | 0
        let creditsUsed = this.currentUser.creditsUsed | 0
        let creditsRemaining = this.currentUser.creditsRemaining | 0
        this.creditsUsed = creditsUsed
        this.creditsRemaining = creditsRemaining
        this.creditsQuota = creditsQuota
    
         
      }
    }
    
    </script>